import * as R from 'ramda';
import { ResortToolsConfig } from '../../auth/config/resortToolsConfig';
import { DEFAULT_CONFIG } from '../../auth/config/defaultConfig';


/**
 * Converts the given resort tools configuration into a model that the config form can act on (since we hide some of the
 * more confusing aspects of the configuration at this time)
 */
export const toFormModel = (config: ResortToolsConfig) => R.mergeDeepRight(config, {
  autoLogoutTimerMs:       config.autoLogoutTimerMs / 1000 / 60,
  loginForwardToTargetMs:  config.loginForwardToTargetMs / 1000 / 60,
  enableGlobalHotlist:     config.enableGlobalHotlist,
  enableResortSpecificHotlist: config.enableResortSpecificHotlist,
  manageValidationConfiguration: config.manageValidationConfiguration,
  enableSearchHistory:           config.enableSearchHistory,
  enablePowCoin :                config.enablePowCoin,
  enableChangeHistory :          config.enableChangeHistory,

});


/**
 * Converts the given config form data back into a valid resort tools configuration
 */
export const fromFormModel = (config): ResortToolsConfig => R.mergeDeepRight(config, {
  autoLogoutTimerMs:       (+config.autoLogoutTimerMs) * 1000 * 60,
  loginForwardToTargetMs:  (+config.loginForwardToTargetMs) * 1000 * 60,
  enableGlobalHotlist:     config.enableGlobalHotlist,
  enableResortSpecificHotlist: config.enableResortSpecificHotlist,
  // For now, always default to the DEFAULT_CONFIG values for who can edit validation configuration
  manageValidationConfiguration:  DEFAULT_CONFIG.manageValidationConfiguration,   
  enableSearchHistory:           config.enableSearchHistory,
  enablePowCoin :                config.enablePowCoin,
  enableChangeHistory :          config.enableChangeHistory,
}) as unknown as ResortToolsConfig;
